import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";

export class GameManager {

    public static initSDK(): void {

        GameVars.intitialised = true;

        const { CrazySDK } = (window as any).CrazyGames;
        GameVars.crazysdk = CrazySDK.getInstance();
        GameVars.crazysdk.init();

        GameVars.crazysdk.addEventListener("adStarted", GameManager.adStarted);
        GameVars.crazysdk.addEventListener("adFinished", GameManager.adFinished);
        GameVars.crazysdk.addEventListener("adError", GameManager.adError);
        // GameVars.crazysdk.addEventListener("adblockDetectionExecuted", GameManager.adblockDetectionExecuted);
        GameVars.crazysdk.addEventListener("bannerRendered", (event) => {
            console.log(`Banner for container ${event.containerId} has been rendered!`);
        });
        GameVars.crazysdk.addEventListener("bannerError", (event) => {
            console.log(`Banner render error: ${event.error}`);
        });

        if (GameVars.crazysdk.hasAdblock) {
            console.log("ADBLOCK");
        } else {
            GameManager.init();
        }

        GameVars.crazysdk.requestBanner([
            {
                containerId: "banner-container",
                size: "320x100",
            }
        ]);

        document.getElementById("banner-container").style.visibility = "hidden";
        
    }

    public static init(): void {

        const domains = ["eagle.games", "crazygames.com", "gioca.re", "1001juegos.com", "onlinegame.co.id", "speelspelletjes.nl", "localhost", "127", "192", "footchinko.com"];

        if (!GameVars.areValidDomains(domains)) {
            return;
        }

        GameVars.currentLevel = 1;
        GameVars.difficulty = GameConstants.DIFFICULTY_EASY;

        if (GameVars.currentScene.sys.game.device.os.desktop) {

            GameVars.scaleY = 1;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            const aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
        }

        GameManager.readGameData();
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        achievedEasyLevel: 0,
                        achievedMediumLevel: 0,
                        achievedDifficultLevel: 0
                    };
                }

                GameManager.startGame();
            }
        );
    }

    public static restoreGameData(): void {

        GameVars.gameData = {
            muted: false,
            achievedEasyLevel: 0,
            achievedMediumLevel: 0,
            achievedDifficultLevel: 0
        };

        GameManager.writeGameData();
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        GameManager.enterSplashScene();
        // GameManager.enterDifficultySelectionScene();
        // GameManager.enterLevelSelectionScene();
        // GameManager.enterBoardScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterDifficultySelectionScene(): void {

        GameVars.currentScene.scene.start("DifficultySelectionScene");
    }

    public static enterLevelSelectionScene(difficutly?: string): void {

        GameVars.difficulty = difficutly || GameVars.difficulty;

        GameVars.currentScene.scene.start("LevelSelectionScene");
    }

    public static enterBoardScene(level?: number): void {

        GameVars.currentLevel = level || GameVars.currentLevel;

        GameVars.crazysdk.requestAd();
    }

    public static goToNextLevel(): void {

        GameVars.currentLevel++;

        if (GameVars.difficulty === GameConstants.DIFFICULTY_EASY && GameVars.currentLevel > GameConstants.TOTAL_EASY_LEVELS) {
            GameVars.currentLevel = 1;
            GameVars.difficulty = GameConstants.DIFFICULTY_NORMAL;
        } else if (GameVars.difficulty === GameConstants.DIFFICULTY_NORMAL && GameVars.currentLevel > GameConstants.TOTAL_NORMAL_LEVELS) {
            GameVars.currentLevel = 1;
            GameVars.difficulty = GameConstants.DIFFICULTY_HERO;
        }

        GameManager.enterBoardScene();
    }

    public static adStarted(): void {

        // AD START
    }

    public static adFinished(): void {
        
        GameVars.currentScene.scene.start("BoardScene");
    }

    public static adError(): void {
        
        GameVars.currentScene.scene.start("BoardScene");
    }

    public static adblockDetectionExecuted(): void {

        if (GameVars.crazysdk.hasAdblock) {
            console.log("ADBLOCK");
        } else {
            GameManager.init();
        }
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
